import type { RouteRecordRaw } from 'vue-router';
import CourseListPage from './pages/CourseListPage/CourseListPage.vue';
import CourseSectionsPage from './pages/CourseSectionsPage/CourseSectionsPage.vue';
import CourseSectionPage from './pages/CourseSectionPage/CourseSectionPage.vue';
import CourseStepPage from './pages/CourseStepPage/CourseStepPage.vue';
import CourseStorePage from './pages/CourseStorePage/CourseStorePage.vue';
import CourseFavoritesPage from './pages/CourseFavoritesPage/CourseFavoritesPage.vue';
import CourseAssignedPage from './pages/CourseAssignedPage/CourseAssignedPage.vue';
import CourseStudentMyPage from './pages/CourseStudentMyPage/CourseStudentMyPage.vue';

export const main: RouteRecordRaw[] = [
  {
    name: 'courses',
    path: 'courses',
    component: CourseStorePage,
    meta: {
      requriesAuth: true,
      headerTitle: 'COURSE_STORE',
    },
  },
  {
    name: 'course.my',
    path: 'course/my',
    component: CourseListPage,
    meta: {
      requriesAuth: true,
      headerTitle: 'MY_COURSES',
    },
  },
  {
    name: 'course.assigned',
    path: 'course/assigned',
    component: CourseAssignedPage,
    meta: {
      requriesAuth: true,
      headerTitle: 'ASSIGNED_COURSES',
    },
  },
  {
    name: 'course.my.student',
    path: 'course/my/student',
    component: CourseStudentMyPage,
    meta: {
      requriesAuth: true,
      headerTitle: 'MY_COURSES',
    },
  },
  {
    name: 'course.favorites',
    path: 'course/favorites',
    component: CourseFavoritesPage,
    meta: {
      requriesAuth: true,
      headerTitle: 'MY_FAVORITES',
    },
  },
  {
    name: 'course.sections',
    path: 'course/:userCourseDocId',
    component: CourseSectionsPage,
    meta: {
      requriesAuth: true,
    },
  },
  {
    name: 'course.sections.section',
    path: 'course/:userCourseDocId/section/:userSectionId/:sectionDocId',
    component: CourseSectionPage,
    meta: {
      requriesAuth: true,
    },
  },
  {
    name: 'course.step',
    path: 'course/:userCourseDocId/section/:userSectionDocId/step/:userStepId/:stepDocId',
    component: CourseStepPage,
    meta: {
      requriesAuth: true,
    },
  },
];

export const base: RouteRecordRaw[] = [];
